import i18next from "i18next";
import React from "react";
import Headline from "~/assets/js/components/Typography/Headline";
import Button from "~/assets/js/components/Button";
import { fetchStoreData } from "~/assets/js/Api/storeApi";

// @deprecated
// const TIP_DORTMUND = "https://app.tippie.de/#/pay/2002760/EUR";
// const TIP_ESSEN = "https://app.tippie.de/#/pay/2002720/EUR";
// const TIP_DUSSELDORF = "https://app.tippie.de/#/pay/2002740/EUR";
// const TIP_MAINZ = "https://app.tippie.de/#/pay/2002970/EUR";
// const TIP_KOLN = "https://app.tippie.de/#/pay/2003000/EUR";
// const TIP_DUISBURG = "https://app.tippie.de/#/pay/2003500/EUR";

const TippingOptions = () => {
    const { area } = window.cookie.get();
    const { store, isLoading } = fetchStoreData(area.store_id);

    if (isLoading) {
        return null;
    }

    return (
        <div className="tipping_options">
            <Headline size={6} resizable>
                {i18next.t("orderConfirmation.tipping.heading")}
            </Headline>
            <p>{i18next.t("orderConfirmation.tipping.notice")}</p>
            <div className="action_buttons">
                {!!store && (
                    <Button
                        variant="secondary"
                        label={i18next.t(`orderConfirmation.tipping.text`, {
                            location: store.locality,
                        })}
                        onClick={() => (location.href = store.tip_url)}
                        customStyle="tip_button"
                    />
                )}
            </div>
        </div>
    );
};

export default TippingOptions;
